import { Theme } from '@mui/material/styles';
import { Breakpoint } from '@mui/system/createTheme/createBreakpoints';
import useMediaQuery from '@mui/material/useMediaQuery';

export const useClintMediaQuery = (query: Breakpoint = 'tablet') => {
  return useMediaQuery((theme: Theme) => theme.breakpoints.down(query));
};
